module.exports = __webpack_public_path__ + "static/media/Lovelo.fca6bef8.otf";


//////////////////
// WEBPACK FOOTER
// ./src/vendor/fonts/Lovelo.otf
// module id = 1513
// module chunks = 0